<!-- @format -->

<form class="reactive" [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (priorLearnings.length === 0) {
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <span class="guidance phase-2-guidance">{{ "PROFILE.APPLICATIONS.PRIOR_LEARNING.PRIOR_LEARNING_INFO" | translate }}</span>
        </div>
      </div>
    </div>
  }
  @if (externalAttainedStudies$ | async; as data) {
    @for (formGroup of priorLearnings.controls; track formGroup; let index = $index) {
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            @if (isPriorStudiesFormGroup(formGroup)) {
              <app-prior-studies-edit
                [formGroup]="formGroup"
                [title]="getPriorLearningEditorTitle(formGroup, index)"
                [externalAttainedStudies]="data"
                (selectExternalAttainedStudy)="onSelectExternalAttainedStudy($event)"
                [emrexIntegrationEnabled]="emrexIntegrationEnabled"
                (delete)="onDeletePriorLearning(index)">
              </app-prior-studies-edit>
            }
            @if (isPriorCompetenceFormGroup(formGroup)) {
              <app-prior-competence-edit
                [formGroup]="formGroup"
                [title]="getPriorLearningEditorTitle(formGroup, index)"
                (delete)="onDeletePriorLearning(index)">
              </app-prior-competence-edit>
            }
          </div>
        </div>
      </div>
    }
  }
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <sis-add-button
          [label]="'PROFILE.APPLICATIONS.PRIOR_LEARNING.ADD' | translate"
          (clicked)="addPriorLearning()"
          dataCy="add-prior-learning"></sis-add-button>
      </div>
    </div>
  </div>
  @if (this.stateService.query.select() | async; as wizardData) {
    <div class="application-attachments">
      <app-application-attachments
        [initialAttachments]="wizardData.fileItems"
        [externalAttainedStudyAttachments]="getAttachedExternalAttainedStudyAttachments(wizardData)"
        (updateAttachments)="updateAttachments($event)">
      </app-application-attachments>
    </div>
  }
  <div class="row">
    <div class="col-12">
      <div class="float-end">
        <sis-button (clicked)="exit.emit()" [naked]="true" data-cy="exit-button">
          <sis-icon icon="back"></sis-icon>
          {{ "SIS_COMPONENTS.BUTTON.EXIT" | translate }}
        </sis-button>
        @if (!hidePreviousButton) {
          <sis-button (clicked)="previousClicked()" hollow="true" data-cy="back-button">
            {{ "SIS_COMPONENTS.BUTTON.PREVIOUS" | translate }}
          </sis-button>
        }
        <sis-button type="submit" data-cy="continue-button">
          {{ "SIS_COMPONENTS.BUTTON.CONTINUE" | translate }}
        </sis-button>
      </div>
    </div>
  </div>
</form>
